import {usePage} from "@inertiajs/vue3";
import {computed} from "vue";
import {Breadcrumb, BreadcrumbItem} from "@/types";

const page = usePage()

const breadcrumbs = computed<BreadcrumbItem[]>(() => {
    const breadcrumbs = page.props.breadcrumbs as Array<Breadcrumb>
    return breadcrumbs.map((breadcrumb: Breadcrumb) => {
        return {
            title: breadcrumb.title,
            disabled: breadcrumb.is_current_page,
            href: breadcrumb.url
        }
    }) as BreadcrumbItem[]
})

export const useBreadcrumb = () => {
    return {
        breadcrumbs,
    }
}
